/**
 * @generated SignedSource<<48eb64f686de1de0ce401f0483726241>>
 * @lightSyntaxTransform
 * @nogrep
 */

/* tslint:disable */
/* eslint-disable */
// @ts-nocheck

import { ReaderFragment } from 'relay-runtime';
import { FragmentRefs } from "relay-runtime";
export type WorkspaceDataTodoGalleryItem_todo$data = {
  readonly createdAtDate: {
    readonly " $fragmentSpreads": FragmentRefs<"StoreFormattedDate">;
  };
  readonly images: ReadonlyArray<{
    readonly id: string;
    readonly " $fragmentSpreads": FragmentRefs<"Image_image">;
  }>;
  readonly store: {
    readonly name: string;
  } | null;
  readonly subject: {
    readonly breadcrumbs: ReadonlyArray<string>;
  } | null;
  readonly title: string;
  readonly " $fragmentType": "WorkspaceDataTodoGalleryItem_todo";
};
export type WorkspaceDataTodoGalleryItem_todo$key = {
  readonly " $data"?: WorkspaceDataTodoGalleryItem_todo$data;
  readonly " $fragmentSpreads": FragmentRefs<"WorkspaceDataTodoGalleryItem_todo">;
};

const node: ReaderFragment = {
  "argumentDefinitions": [],
  "kind": "Fragment",
  "metadata": null,
  "name": "WorkspaceDataTodoGalleryItem_todo",
  "selections": [
    {
      "alias": null,
      "args": null,
      "concreteType": "TodoSubject",
      "kind": "LinkedField",
      "name": "subject",
      "plural": false,
      "selections": [
        {
          "alias": null,
          "args": [
            {
              "kind": "Literal",
              "name": "style",
              "value": "FULL"
            }
          ],
          "kind": "ScalarField",
          "name": "breadcrumbs",
          "storageKey": "breadcrumbs(style:\"FULL\")"
        }
      ],
      "storageKey": null
    },
    {
      "alias": null,
      "args": null,
      "concreteType": "StoreZonedDate",
      "kind": "LinkedField",
      "name": "createdAtDate",
      "plural": false,
      "selections": [
        {
          "args": null,
          "kind": "FragmentSpread",
          "name": "StoreFormattedDate"
        }
      ],
      "storageKey": null
    },
    {
      "alias": null,
      "args": null,
      "concreteType": "Store",
      "kind": "LinkedField",
      "name": "store",
      "plural": false,
      "selections": [
        {
          "alias": null,
          "args": null,
          "kind": "ScalarField",
          "name": "name",
          "storageKey": null
        }
      ],
      "storageKey": null
    },
    {
      "alias": null,
      "args": null,
      "kind": "ScalarField",
      "name": "title",
      "storageKey": null
    },
    {
      "alias": null,
      "args": null,
      "concreteType": "Image",
      "kind": "LinkedField",
      "name": "images",
      "plural": true,
      "selections": [
        {
          "alias": null,
          "args": null,
          "kind": "ScalarField",
          "name": "id",
          "storageKey": null
        },
        {
          "args": null,
          "kind": "FragmentSpread",
          "name": "Image_image"
        }
      ],
      "storageKey": null
    }
  ],
  "type": "Todo",
  "abstractKey": null
};

(node as any).hash = "6a12f2582d50e30a14e4714e3b99276a";

export default node;
